import React, { useState, useEffect } from 'react';
import { getWorkerFailures } from '../api';

/**
 * Журнал збоїв машини — відкривається кліком по бейджу «збої: N» на /cluster.
 *
 * Кожен рядок — комбінація, яку машина здала БЕЗ результату, і причина, яку
 * назвав агент. «Машин» — на скількох машинах та сама комбінація вже не
 * вдалась: якщо на кількох, справа найімовірніше в самій комбінації.
 * Історії живуть разом із ключами сітки, тож давні збої тут уже не видно,
 * а лічильник на рядку машини — накопичений.
 */
export default function NodeFailuresModal({ worker, onClose }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [open, setOpen] = useState(null);

  useEffect(() => {
    let alive = true;
    getWorkerFailures(worker.agent_id)
      .then(res => { if (alive) setData(res.data); })
      .catch(e => { if (alive) setErr(e?.response?.data?.detail || e.message || 'не завантажилось'); });
    return () => { alive = false; };
  }, [worker.agent_id]);

  const fmt = ts => ts ? new Date(ts * 1000).toLocaleString('uk-UA', {
    day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
  }) : '—';
  const items = data?.items || [];

  return (
    <div style={S.back} onClick={onClose}>
      <div style={S.box} onClick={e => e.stopPropagation()}>
        <div style={S.head}>
          <b>Збої «{worker.name}»</b>
          <button style={S.x} onClick={onClose}>✕</button>
        </div>
        <div style={S.note}>
          Комбінації, які машина здала без результату. Усього на лічильнику — {worker.fail_count};
          тут — ті, чиї сітки ще зберігаються на сервері
          {data ? ` (${data.total}${data.total > items.length ? `, показано ${items.length} найсвіжіших` : ''})` : ''}.
          Клік по рядку — повний текст причини.
        </div>
        {!data && !err && <div style={S.note}>Завантажую…</div>}
        {err && <div style={S.warn}>{err}</div>}
        {data && !items.length && <div style={S.note}>Записів немає — сітки, де були збої, вже прибрано.</div>}
        {items.length > 0 && (
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Коли</th>
                <th style={S.th}>Сітка</th>
                <th style={S.th}>№</th>
                <th style={S.th} title="На скількох машинах ця комбінація не вдалась">Машин</th>
                <th style={S.th}>Причина</th>
              </tr>
            </thead>
            <tbody>
              {items.map((f, k) => (
                <tr key={k} onClick={() => setOpen(open === k ? null : k)} style={{ cursor: 'pointer' }}>
                  <td style={{ ...S.td, whiteSpace: 'nowrap' }}>{fmt(f.ts)}</td>
                  <td style={{ ...S.td, fontFamily: 'monospace' }} title={f.bid}>{String(f.bid).slice(0, 8)}</td>
                  <td style={S.td}>{f.combo_index}</td>
                  <td style={{ ...S.td, color: f.machines > 1 ? '#B45309' : undefined }}>{f.machines}</td>
                  <td style={{ ...S.td, ...(open === k ? S.full : S.cut) }}>{f.reason || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const S = {
  back: { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.35)', zIndex: 1000,
          display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
          padding: '40px 12px', overflowY: 'auto' },
  box:  { background: '#fff', borderRadius: 10, padding: '16px 18px', width: 'min(900px, 100%)',
          boxShadow: '0 12px 32px rgba(15,23,42,0.2)', fontSize: 13.5, color: '#1A1A1A' },
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 },
  x:    { border: 'none', background: 'none', fontSize: 18, cursor: 'pointer', color: '#5B646F' },
  note: { color: '#5B646F', fontSize: 12.5, lineHeight: 1.5, marginBottom: 10 },
  warn: { color: '#B91C1C', fontSize: 12.5, marginBottom: 10 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 12.5 },
  th:   { textAlign: 'left', padding: '6px 6px', borderBottom: '1px solid #E5E7EB',
          color: '#5B646F', fontWeight: 600 },
  td:   { padding: '5px 6px', borderBottom: '1px solid #F1F3F5', verticalAlign: 'top' },
  cut:  { maxWidth: 480, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  full: { whiteSpace: 'pre-wrap', wordBreak: 'break-word' },
};
